export const config = {
  title: "Herminio's Framing LLC | Expert Framing Services in San Antonio, TX",
  meta: {
    description:
      "Herminio's Framing LLC offers professional residential and commercial framing services in San Antonio, TX. Specializing in wall framing, room additions, wood structures, and custom remodels.",
    keywords: [
      "Herminio's Framing LLC",
      "Framing Services San Antonio",
      "Wall Framing",
      "Room Additions",
      "Wood Structures",
      "Custom Remodels",
      "Deck Construction",
      "Patio Covers",
      "Pergolas",
      "Garage Framing"
    ],
    author: "Herminio's Framing LLC",
    canonicalUrl: "https://herminiosframingllc.com/"
  },
  sections: {
    header: {
      businessName: "Herminio's Framing LLC"
    },
    sectionB: {
      heroTitle: "Building Quality Structures with Precision",
      heroSubtitle: "Expert Framing Services in San Antonio, TX",
      learnAboutText: "Learn More",
      phoneNumber: "2103138239",
      phoneLabel: "(210) 313-8239",
      heroBackgroundImage:
        "https://herminiosframingllc.com/assets/gallery2.JPG",
      cardData: [
        {
          title: "Residential Framing",
          description:
            "Customized framing solutions for new homes, additions, and remodels."
        },
        {
          title: "Commercial Projects",
          description:
            "Reliable framing services tailored for commercial construction needs."
        },
        {
          title: "Outdoor Structures",
          description:
            "Expert construction of decks, patios, pergolas, and exterior wood features."
        }
      ],
      description:
        "At Herminio's Framing LLC, we specialize in delivering high-quality framing services in San Antonio, TX. From residential projects to commercial constructions, our experienced team ensures excellence in every build."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive framing solutions for all your construction needs.",
      cards: [
        {
          title: "Wall Framing",
          description:
            "Precision wall framing for residential and commercial structures.",
          imageSrc: "https://herminiosframingllc.com/assets/gallery3.JPG",
          imageAlt: "Wall Framing"
        },
        {
          title: "Room Additions",
          description:
            "Seamless integration of new rooms into existing structures.",
          imageSrc: "https://herminiosframingllc.com/assets/gallery4.JPG",
          imageAlt: "Room Additions"
        },
        {
          title: "Deck Construction",
          description:
            "Durable and aesthetically pleasing deck construction services.",
          imageSrc: "https://herminiosframingllc.com/assets/gallery1.JPG",
          imageAlt: "Deck Construction"
        }
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Wood Structures",
        "Custom Remodels",
        "Fence Installation",
        "Patio Covers & Pergolas",
        "Exterior Wood Repairs",
        "Garage & Carport Framing",
        "Structural Reinforcements"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://herminiosframingllc.com/assets/logo.png",
        alt: "Herminio's Framing LLC Team"
      },
      aboutText: [
        "Herminio's Framing LLC is a trusted framing company based in San Antonio, TX. With years of experience, we are committed to delivering top-notch framing services tailored to our clients' needs.",
        "Our mission is to provide durable and aesthetically pleasing framing solutions, ensuring customer satisfaction in every project we undertake."
      ]
    },
    sectionE: {
      profileImage: "https://herminiosframingllc.com/assets/logo.png",
      profileAlt: "Herminio's Framing LLC Logo",
      businessName: "Herminio's Framing LLC",
      contact: {
        phone: "2103138239",
        phoneLabel: "(210) 313-8239",
        email: "contact@herminiosframingLLC.com",
        website: "https://herminiosframingllc.com/",
        address: "San Antonio, TX 78220"
      },
      socialMedia: {
        facebook: null, // Add Facebook URL if available
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null // Add YouTube URL if available
      }
    },
    sectionF: {
      address: "San Antonio, TX 78220",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3475.123456789!2d-98.123456!3d29.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c1234567890ab%3A0x123456789abcdef!2sSan%20Antonio%2C%20TX%2078220!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus"
    }
  }
};

export default config;
